import { authorLinkIcon } from "@/helpers/author";

export default {
  name: "author-about",
  props: {
    author: {
      type: Object,
      required: true,
    },
  },
  computed: {
    authorLink() {
      return this.$localize({ name: "author", params: { slug: this.author.slug } });
    },
    articlesLink() {
      return { ...this.authorLink, hash: "#articles" };
    },
    links() {
      return this.author.links || [];
    },
  },
  methods: {
    linkIcon(type) {
      return authorLinkIcon(type);
    },
  },
};
